export default {
  base: {
    fontSize: 20,
    mr: 12,
    variant: 'spark.base.wrapper'
  }
};